/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { financingSourcesCapexVarinatsRetrieve } from '../fn/credits/financing-sources-capex-varinats-retrieve';
import { FinancingSourcesCapexVarinatsRetrieve$Params } from '../fn/credits/financing-sources-capex-varinats-retrieve';
import { financingSourcesLeasingsCopyCreate } from '../fn/leasings/financing-sources-leasings-copy-create';
import { FinancingSourcesLeasingsCopyCreate$Params } from '../fn/leasings/financing-sources-leasings-copy-create';
import { financingSourcesLeasingsCreate } from '../fn/leasings/financing-sources-leasings-create';
import { financingSourcesLeasingsCreate$FormData } from '../fn/leasings/financing-sources-leasings-create-form-data';
import { FinancingSourcesLeasingsCreate$FormData$Params } from '../fn/leasings/financing-sources-leasings-create-form-data';
import { FinancingSourcesLeasingsCreate$Params } from '../fn/leasings/financing-sources-leasings-create';
import { financingSourcesLeasingsCreate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-create-x-www-form-urlencoded';
import { FinancingSourcesLeasingsCreate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-create-x-www-form-urlencoded';
import { financingSourcesLeasingsDestroy } from '../fn/leasings/financing-sources-leasings-destroy';
import { FinancingSourcesLeasingsDestroy$Params } from '../fn/leasings/financing-sources-leasings-destroy';
import { financingSourcesLeasingsEnumsRetrieve } from '../fn/leasings/financing-sources-leasings-enums-retrieve';
import { FinancingSourcesLeasingsEnumsRetrieve$Params } from '../fn/leasings/financing-sources-leasings-enums-retrieve';
import { financingSourcesLeasingsList } from '../fn/leasings/financing-sources-leasings-list';
import { FinancingSourcesLeasingsList$Params } from '../fn/leasings/financing-sources-leasings-list';
import { financingSourcesLeasingsPartialUpdate } from '../fn/leasings/financing-sources-leasings-partial-update';
import { financingSourcesLeasingsPartialUpdate$FormData } from '../fn/leasings/financing-sources-leasings-partial-update-form-data';
import { FinancingSourcesLeasingsPartialUpdate$FormData$Params } from '../fn/leasings/financing-sources-leasings-partial-update-form-data';
import { FinancingSourcesLeasingsPartialUpdate$Params } from '../fn/leasings/financing-sources-leasings-partial-update';
import { financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-partial-update-x-www-form-urlencoded';
import { FinancingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-partial-update-x-www-form-urlencoded';
import { financingSourcesLeasingsRetrieve } from '../fn/leasings/financing-sources-leasings-retrieve';
import { FinancingSourcesLeasingsRetrieve$Params } from '../fn/leasings/financing-sources-leasings-retrieve';
import { financingSourcesLeasingsUpdate } from '../fn/leasings/financing-sources-leasings-update';
import { financingSourcesLeasingsUpdate$FormData } from '../fn/leasings/financing-sources-leasings-update-form-data';
import { FinancingSourcesLeasingsUpdate$FormData$Params } from '../fn/leasings/financing-sources-leasings-update-form-data';
import { FinancingSourcesLeasingsUpdate$Params } from '../fn/leasings/financing-sources-leasings-update';
import { financingSourcesLeasingsUpdate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-update-x-www-form-urlencoded';
import { FinancingSourcesLeasingsUpdate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-update-x-www-form-urlencoded';
import { financingSourcesLeasingsVariantsCopyCreate } from '../fn/leasings/financing-sources-leasings-variants-copy-create';
import { FinancingSourcesLeasingsVariantsCopyCreate$Params } from '../fn/leasings/financing-sources-leasings-variants-copy-create';
import { financingSourcesLeasingsVariantsCreate } from '../fn/leasings/financing-sources-leasings-variants-create';
import { financingSourcesLeasingsVariantsCreate$FormData } from '../fn/leasings/financing-sources-leasings-variants-create-form-data';
import { FinancingSourcesLeasingsVariantsCreate$FormData$Params } from '../fn/leasings/financing-sources-leasings-variants-create-form-data';
import { FinancingSourcesLeasingsVariantsCreate$Params } from '../fn/leasings/financing-sources-leasings-variants-create';
import { financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-variants-create-x-www-form-urlencoded';
import { FinancingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-variants-create-x-www-form-urlencoded';
import { financingSourcesLeasingsVariantsDestroy } from '../fn/leasings/financing-sources-leasings-variants-destroy';
import { FinancingSourcesLeasingsVariantsDestroy$Params } from '../fn/leasings/financing-sources-leasings-variants-destroy';
import { financingSourcesLeasingsVariantsList } from '../fn/leasings/financing-sources-leasings-variants-list';
import { FinancingSourcesLeasingsVariantsList$Params } from '../fn/leasings/financing-sources-leasings-variants-list';
import { financingSourcesLeasingsVariantsPartialUpdate } from '../fn/leasings/financing-sources-leasings-variants-partial-update';
import { financingSourcesLeasingsVariantsPartialUpdate$FormData } from '../fn/leasings/financing-sources-leasings-variants-partial-update-form-data';
import { FinancingSourcesLeasingsVariantsPartialUpdate$FormData$Params } from '../fn/leasings/financing-sources-leasings-variants-partial-update-form-data';
import { FinancingSourcesLeasingsVariantsPartialUpdate$Params } from '../fn/leasings/financing-sources-leasings-variants-partial-update';
import { financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-variants-partial-update-x-www-form-urlencoded';
import { FinancingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-variants-partial-update-x-www-form-urlencoded';
import { financingSourcesLeasingsVariantsRetrieve } from '../fn/leasings/financing-sources-leasings-variants-retrieve';
import { FinancingSourcesLeasingsVariantsRetrieve$Params } from '../fn/leasings/financing-sources-leasings-variants-retrieve';
import { financingSourcesLeasingsVariantsUpdate } from '../fn/leasings/financing-sources-leasings-variants-update';
import { financingSourcesLeasingsVariantsUpdate$FormData } from '../fn/leasings/financing-sources-leasings-variants-update-form-data';
import { FinancingSourcesLeasingsVariantsUpdate$FormData$Params } from '../fn/leasings/financing-sources-leasings-variants-update-form-data';
import { FinancingSourcesLeasingsVariantsUpdate$Params } from '../fn/leasings/financing-sources-leasings-variants-update';
import { financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-leasings-variants-update-x-www-form-urlencoded';
import { FinancingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-leasings-variants-update-x-www-form-urlencoded';
import { financingSourcesUnblockLeasingsVariantsCreate } from '../fn/leasings/financing-sources-unblock-leasings-variants-create';
import { financingSourcesUnblockLeasingsVariantsCreate$FormData } from '../fn/leasings/financing-sources-unblock-leasings-variants-create-form-data';
import { FinancingSourcesUnblockLeasingsVariantsCreate$FormData$Params } from '../fn/leasings/financing-sources-unblock-leasings-variants-create-form-data';
import { FinancingSourcesUnblockLeasingsVariantsCreate$Params } from '../fn/leasings/financing-sources-unblock-leasings-variants-create';
import { financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded } from '../fn/leasings/financing-sources-unblock-leasings-variants-create-x-www-form-urlencoded';
import { FinancingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/leasings/financing-sources-unblock-leasings-variants-create-x-www-form-urlencoded';
import { BackendIdDto } from '../models/backend-id-dto';
import { BackendLeasingContractDto } from '../models/backend-leasing-contract-dto';
import { BackendLeasingContractVariantDto } from '../models/backend-leasing-contract-variant-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiLeasingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financingSourcesCapexVarinatsRetrieve()` */
  static readonly FinancingSourcesCapexVarinatsRetrievePath = '/api/financing_sources/capex_varinats/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCapexVarinatsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCapexVarinatsRetrieve$Response(
    params: FinancingSourcesCapexVarinatsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCapexVarinatsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCapexVarinatsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCapexVarinatsRetrieve(
    params: FinancingSourcesCapexVarinatsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCapexVarinatsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsList()` */
  static readonly FinancingSourcesLeasingsListPath = '/api/financing_sources/leasings/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsList$Response(
    params?: FinancingSourcesLeasingsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendLeasingContractDto>>> {
    return financingSourcesLeasingsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsList(
    params?: FinancingSourcesLeasingsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendLeasingContractDto>> {
    return this.financingSourcesLeasingsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendLeasingContractDto>>): Array<BackendLeasingContractDto> => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsCreate()` */
  static readonly FinancingSourcesLeasingsCreatePath = '/api/financing_sources/leasings/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsCreate$Response(
    params: FinancingSourcesLeasingsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsCreate(
    params: FinancingSourcesLeasingsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsCreate$FormData$Response(
    params: FinancingSourcesLeasingsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsCreate$FormData(
    params: FinancingSourcesLeasingsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsRetrieve()` */
  static readonly FinancingSourcesLeasingsRetrievePath = '/api/financing_sources/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsRetrieve$Response(
    params: FinancingSourcesLeasingsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsRetrieve(
    params: FinancingSourcesLeasingsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsUpdate()` */
  static readonly FinancingSourcesLeasingsUpdatePath = '/api/financing_sources/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsUpdate$Response(
    params: FinancingSourcesLeasingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsUpdate(
    params: FinancingSourcesLeasingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsUpdate$FormData$Response(
    params: FinancingSourcesLeasingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsUpdate$FormData(
    params: FinancingSourcesLeasingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsDestroy()` */
  static readonly FinancingSourcesLeasingsDestroyPath = '/api/financing_sources/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsDestroy$Response(
    params: FinancingSourcesLeasingsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesLeasingsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsDestroy(
    params: FinancingSourcesLeasingsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesLeasingsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsPartialUpdate()` */
  static readonly FinancingSourcesLeasingsPartialUpdatePath = '/api/financing_sources/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsPartialUpdate$Response(
    params: FinancingSourcesLeasingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsPartialUpdate(
    params: FinancingSourcesLeasingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsPartialUpdate$FormData$Response(
    params: FinancingSourcesLeasingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
    return financingSourcesLeasingsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsPartialUpdate$FormData(
    params: FinancingSourcesLeasingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractDto> {
    return this.financingSourcesLeasingsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractDto>): BackendLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsCopyCreate()` */
  static readonly FinancingSourcesLeasingsCopyCreatePath = '/api/financing_sources/leasings/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsCopyCreate$Response(
    params: FinancingSourcesLeasingsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesLeasingsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsCopyCreate(
    params: FinancingSourcesLeasingsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesLeasingsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsEnumsRetrieve()` */
  static readonly FinancingSourcesLeasingsEnumsRetrievePath = '/api/financing_sources/leasings/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsEnumsRetrieve$Response(
    params: FinancingSourcesLeasingsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesLeasingsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsEnumsRetrieve(
    params: FinancingSourcesLeasingsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesLeasingsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsList()` */
  static readonly FinancingSourcesLeasingsVariantsListPath = '/api/financing_sources/leasings_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsList$Response(
    params?: FinancingSourcesLeasingsVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendLeasingContractVariantDto>>> {
    return financingSourcesLeasingsVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsList(
    params?: FinancingSourcesLeasingsVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendLeasingContractVariantDto>> {
    return this.financingSourcesLeasingsVariantsList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendLeasingContractVariantDto>>): Array<BackendLeasingContractVariantDto> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsCreate()` */
  static readonly FinancingSourcesLeasingsVariantsCreatePath = '/api/financing_sources/leasings_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsCreate$Response(
    params: FinancingSourcesLeasingsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsCreate(
    params: FinancingSourcesLeasingsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsCreate$FormData$Response(
    params: FinancingSourcesLeasingsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsCreate$FormData(
    params: FinancingSourcesLeasingsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsRetrieve()` */
  static readonly FinancingSourcesLeasingsVariantsRetrievePath = '/api/financing_sources/leasings_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsRetrieve$Response(
    params: FinancingSourcesLeasingsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsRetrieve(
    params: FinancingSourcesLeasingsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsUpdate()` */
  static readonly FinancingSourcesLeasingsVariantsUpdatePath = '/api/financing_sources/leasings_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsUpdate$Response(
    params: FinancingSourcesLeasingsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsUpdate(
    params: FinancingSourcesLeasingsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsUpdate$FormData$Response(
    params: FinancingSourcesLeasingsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsUpdate$FormData(
    params: FinancingSourcesLeasingsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsDestroy()` */
  static readonly FinancingSourcesLeasingsVariantsDestroyPath = '/api/financing_sources/leasings_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsDestroy$Response(
    params: FinancingSourcesLeasingsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesLeasingsVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsDestroy(
    params: FinancingSourcesLeasingsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesLeasingsVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsPartialUpdate()` */
  static readonly FinancingSourcesLeasingsVariantsPartialUpdatePath = '/api/financing_sources/leasings_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsPartialUpdate$Response(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesLeasingsVariantsPartialUpdate(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsPartialUpdate$FormData$Response(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
    return financingSourcesLeasingsVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesLeasingsVariantsPartialUpdate$FormData(
    params: FinancingSourcesLeasingsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendLeasingContractVariantDto> {
    return this.financingSourcesLeasingsVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendLeasingContractVariantDto>): BackendLeasingContractVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesLeasingsVariantsCopyCreate()` */
  static readonly FinancingSourcesLeasingsVariantsCopyCreatePath =
    '/api/financing_sources/leasings_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesLeasingsVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsCopyCreate$Response(
    params: FinancingSourcesLeasingsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesLeasingsVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesLeasingsVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesLeasingsVariantsCopyCreate(
    params: FinancingSourcesLeasingsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesLeasingsVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesUnblockLeasingsVariantsCreate()` */
  static readonly FinancingSourcesUnblockLeasingsVariantsCreatePath =
    '/api/financing_sources/unblock-leasings-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockLeasingsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockLeasingsVariantsCreate$Response(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockLeasingsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockLeasingsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockLeasingsVariantsCreate(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockLeasingsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockLeasingsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockLeasingsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockLeasingsVariantsCreate$FormData$Response(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockLeasingsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockLeasingsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockLeasingsVariantsCreate$FormData(
    params: FinancingSourcesUnblockLeasingsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockLeasingsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
